import {
    Button,
    Grid,
    Paper,
    TextField,
    FormHelperText,
    Typography
} from '@mui/material'

import qs from 'qs'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { ROUTELOGIN, ROUTEHOME } from '../../routes'
import { AppState } from 'src/store'
import {
    addSnackbar,
    changePage
} from '../../actions'
import { Error } from 'src/domains/explorer/types';
import Header from '../components/Header';
import { changePageTitle } from '../../actions';

const renderErrors = (errors: { [key: string]: Error[] }, name: string) => {
    const errKey = '/' + name;
    return errors[errKey] && errors[errKey].map((err, index) => (
        <FormHelperText
            id={'field-error-' + name}
            key={index}
            sx={{ color: theme => theme.palette.error.main }}
        >
            {err.message}
        </FormHelperText>
    ))
};

const renderConfirmMessage = () => {
    return <Grid
        container
        direction='column'
        justifyContent='space-around'
        spacing={1}
    >
        <Typography>{'An email has been sent with password reset link, which you can use to reset your password. It will expire in 30 minutes.'}</Typography>
    </Grid>
};

const RequestResetPassword: React.FC = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState(''); // email (user)
    const [errors, setErrors] = useState<{ [key: string]: Error[] }>({});
    const [resetSent, setResetSent] = useState<boolean>(false);
    const location = useLocation();

    const apiEndpoint = useSelector((state: AppState) => state.global.options.baseUrl);

    useEffect(() => {
        dispatch(changePageTitle('Reset Password'));
    }, []);

    useEffect(() => {
        setEmail('');
        setErrors({});
        setResetSent(false);
    }, [location.key]);

    const requestReset = async () => {
        let endpoint = apiEndpoint + '/requestReset';

        let body = {
            email
        };

        let options: RequestInit = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: qs.stringify(body),
        };

        try {
            let response = await fetch(endpoint, options)
            if (response.status === 200) {
                // const user: any = await response.json();
                dispatch(addSnackbar('Reset link sent!', 'resetSentSuccess', {}));
                // setTimeout(() => {
                //     dispatch(changePage(ROUTELOGIN));
                // }, 1);
                setResetSent(true);
            } else {
                dispatch(addSnackbar('Reset password error!', 'resetPassError', {}));
                let text = await response.text();
                if (text.length > 0) {
                    const data = JSON.parse(text);
                    setErrors(data);
                }
            }
        } catch (err) {
            dispatch(addSnackbar('Reset password error!', 'resetPassError', {}));
        }

    }

    const cancel = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(ROUTEHOME));
    }

    return (<>
        <Header />
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', backgroundColor: theme => theme.palette.grey[300] }}
        >

            <Grid size={3}>

                <Paper sx={{ p: 1 }}>
                    {!resetSent ? <>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                            marginBottom={1}
                        >
                            <Grid>
                                {
                                    errors['/'] && errors['/'].map((err, index) => (
                                        <FormHelperText key={index} error>
                                            {err.message}
                                        </FormHelperText>
                                    ))
                                }
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                        >

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'email'}
                                    fullWidth
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {
                                    renderErrors(errors, 'userKey')
                                }
                            </Grid>

                            <Grid>
                                <Grid
                                    container
                                    direction='row'
                                    alignItems='center'
                                    justifyContent='space-around'
                                >
                                    <Grid>
                                        <Button variant='outlined' size="small" onClick={cancel}>{'Cancel'}</Button>
                                    </Grid>
                                    <Grid>
                                        <Button variant='contained' size="small" onClick={requestReset}>{'Submit'}</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </> : renderConfirmMessage()
                    }
                </Paper>
            </Grid>
        </Grid>
    </>)
}

export default RequestResetPassword;
